"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Weglot = void 0;
const BR_1 = __importDefault(require("country-flag-icons/react/3x2/BR"));
const US_1 = __importDefault(require("country-flag-icons/react/3x2/US"));
const ES_1 = __importDefault(require("country-flag-icons/react/3x2/ES"));
const FR_1 = __importDefault(require("country-flag-icons/react/3x2/FR"));
const DE_1 = __importDefault(require("country-flag-icons/react/3x2/DE"));
const cfOutput_1 = __importDefault(require("root/cfOutput"));
const { domainName } = cfOutput_1.default;
// eslint-disable-next-line import/prefer-default-export
exports.Weglot = {
    scriptUrl: 'https://cdn.weglot.com/weglot.min.js',
    // Note: see the full list of options: https://developers.weglot.com/javascript/options
    initScript: (key) => `Weglot.initialize({
		"api_key": "${key}",
		"cache": true,
		"hide_switcher": true
	})`,
    languageCodes: [
        'en',
        'es',
        'br',
        'fr',
        'de',
    ],
    origins: [
        `https://${domainName}`,
        `https://es.${domainName}`,
        `https://pt-br.${domainName}`,
        `https://fr.${domainName}`,
        `https://de.${domainName}`,
    ],
    dnsSettings: {
        type: 'CNAME',
        value: 'websites.weglot.com.',
        names: [
            `es.${domainName}`,
            `pt-br.${domainName}`,
            `fr.${domainName}`,
            `de.${domainName}`,
        ],
    },
    flagComponents: {
        en: US_1.default,
        es: ES_1.default,
        br: BR_1.default,
        fr: FR_1.default,
        de: DE_1.default,
    },
    languageNames: {
        en: 'English',
        es: 'Español',
        br: 'Português',
        fr: 'Français',
        de: 'Deutsch',
    },
};
